<template>
  <base-edit-form
    :edit-form="editForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-edit-form>
</template>

<script>
import { BaseEditForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import formatDateTime from "@/core/utils/formatTime";
import { ProgramCriterionCategoriesService } from "../../../services/programCriterionCategories.service";

export default {
  name: "ProgramCriterionCategoryEditForm",
  components: { BaseEditForm },
  data() {
    return {
      params: {
        name: null,
        description: null
      },
      formTitle: this.$t("page_title.program_criterion_category_edit"),
      editForm: [
        {
          label: this.$t("program_criterion_category.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("program_criterion_category.description"),
          name: "description",
          value: "",
          type: "textarea",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "CriterionCategoryList" });
    },
    async submitForm(params) {
      const response = await new ProgramCriterionCategoriesService().update(
        this.$route.params.id,
        params
      );
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          value: sanitizer.escape(response.name),
          name: this.$t("program_criterion_category.title")
        }),
        type: "success"
      });
    },
    async getDetail() {
      let info = await new ProgramCriterionCategoriesService().getById(
        this.$route.params.id
      );
      this.params.name = this.editForm[0].value = info.name;
      this.params.description = this.editForm[1].value = info.description;
      this.params.created_by = info.created_by;
      this.params.created_at = info.created_at
        ? formatDateTime(info.created_at)
        : "";
      this.params.updated_at = info.updated_at
        ? formatDateTime(info.updated_at)
        : "";
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style scoped></style>
